
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import logo from "../../../asset/images/shubham_removebg.png";
import appConfig from "../../../config/appConfig";
import { AiFillProduct } from "react-icons/ai";
import { TiWarning } from "react-icons/ti";
import { HiDuplicate } from "react-icons/hi";
import { IoIosSend, IoIosClose } from "react-icons/io";
import { FaThumbsUp } from "react-icons/fa6";
import { BsBoxSeamFill } from "react-icons/bs";
import { FcDeleteDatabase } from "react-icons/fc";
import { MdReportProblem } from "react-icons/md";
import { FaCheckCircle, FaGift, FaAward, FaHistory } from "react-icons/fa";
import { decodeTagrosToken, formatDate } from "./common";

const generateUUID = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    try {
      return crypto.randomUUID();
    } catch (e) {
      // fallback
    }
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const getDeviceInfo = () => {
  let deviceId = null;
  try {
    deviceId = localStorage.getItem("deviceId");
  } catch (e) {
    // storage unavailable
  }
  let isUnique = 0;

  if (!deviceId) {
    deviceId = generateUUID();
    try {
      localStorage.setItem("deviceId", deviceId);
    } catch (e) {
      // storage unavailable
    }
    console.log("Generated new deviceId:", deviceId);
    isUnique = 1;
  }

  return { deviceId, isUnique };
};

const TagrosProductDetailsPage = () => {
  const fullUrl = window.location.href;

  console.log(fullUrl);
  // Example:
  // https://example.com/tagros/product/ABC123
  const params = useParams();
  const sku = params.sku || params.token;
  const [product, setProduct] = useState(null);
  const [decodedRsn, setDecodedRsn] = useState(null);
  const [encodedRsn, setEncodedRsn] = useState(null);
  const [encodedSku, setEncodedSku] = useState(null);
  const [signature, setSignature] = useState(null);
  const [tokenCandidate, setTokenCandidate] = useState(null);
  const [displayConfig, setDisplayConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gpsStatus, setGpsStatus] = useState(null);
  const [message, setMessage] = useState(null);
  const [scanStatus, setScanStatus] = useState(null);
  const [feedbackList, setFeedbackList] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [sendingFeedback, setSendingFeedback] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [plantLocation, setPlantLocation] = useState(null);
  const removeProtocol = (url) => {
    return url.replace(/^https?:\/\//, "");
  };
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");

  const [showConfigPanel, setShowConfigPanel] = useState(false);

  // Royalty / Reward points claim state
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileSubmitted, setMobileSubmitted] = useState(false);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [savedMobile, setSavedMobile] = useState("");
  const [isEditingMobile, setIsEditingMobile] = useState(false);
  const [lastLocationId, setLastLocationId] = useState(null);

  // Loyalty modal & history state
  const [showLoyaltyModal, setShowLoyaltyModal] = useState(false);
  const [loyaltyHistory, setLoyaltyHistory] = useState([]);
  const [totalLoyaltyPoints, setTotalLoyaltyPoints] = useState(0);
  const [fetchingHistory, setFetchingHistory] = useState(false);
  const [showHistorySheet, setShowHistorySheet] = useState(false);
  const [claimAnimStage, setClaimAnimStage] = useState("idle"); // 'idle' | 'reward'
  const [justClaimed, setJustClaimed] = useState(false);
  const [animKey, setAnimKey] = useState(0);

  const startClaimAnimation = () => {
    try {
      if (navigator?.vibrate) {
        navigator.vibrate([40, 60, 40]);
      }
    } catch (e) { }

    setAnimKey((prev) => prev + 1);
    setClaimAnimStage("reward");
  };

  const fetchLoyaltyHistory = async (phone) => {
    if (!phone) return;
    try {
      setFetchingHistory(true);
      const res = await fetch(`${appConfig.apiBaseUrl}/tagros/loyaltyHistory/${phone}`);
      const result = await res.json();
      if (result.success) {
        setTotalLoyaltyPoints(result.totalPoints || 0);
        const rewardedHistory = (result.history || []).filter(
          (item) => Number(item.RoyaltyPoints || item.Points || item.points || 0) > 0
        );
        setLoyaltyHistory(rewardedHistory);
      }
    } catch (err) {
      console.error("Failed to fetch loyalty history:", err);
    } finally {
      setFetchingHistory(false);
    }
  };

  const isOriginalProduct = scanStatus?.id === 1 || scanStatus?.name === "Original Product" || product?.status?.id === 1;
  const isProductRewardClaimed = Boolean(
    product?.IsAlreadyRewarded ||
    (loyaltyHistory && loyaltyHistory.some((item) => {
      const itemRsn = item.RSNID || item.rsnid;
      return (
        (product?.RSNID && String(itemRsn) === String(product.RSNID)) ||
        (product?.SKU && String(itemRsn) === String(product.SKU))
      );
    }))
  );

  const claimPointsForMobile = async (targetMobile) => {
    const clean = String(targetMobile || savedMobile || mobileNumber || "").replace(/\D/g, "");
    if (clean.length < 10) {
      setMobileError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setMobileLoading(true);
    setMobileError("");
    try {
      const { deviceId } = getDeviceInfo();
      const res = await fetch(`${appConfig.apiBaseUrl}/tagros/saveUserMobile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          DeviceID: deviceId,
          LocationID: lastLocationId,
          MobileNumber: clean,
          RSNID: product?.RSNID || null,
          SKU: product?.SKU || null,
          ProductID: product?.productId || null,
          BatchID: product?.BatchID || null,
          CompanyID: product?.CompanyID || null,
          RoyaltyPoints: product?.EarnedPoints || 0,
          Status: scanStatus?.id ?? null,
        }),
      });

      const resData = await res.json().catch(() => ({}));
      if (res.ok && resData.success) {
        setMobileSubmitted(true);
        setSavedMobile(clean);
        setIsEditingMobile(false);
        setTotalLoyaltyPoints(Number(resData.totalPoints ?? (product?.EarnedPoints || 0)));
        const rewardedHistory = (resData.history || []).filter(
          (item) => Number(item.RoyaltyPoints || item.Points || item.points || 0) > 0
        );
        setLoyaltyHistory(rewardedHistory);
        localStorage.setItem(`user_mobile_${deviceId}`, clean);

        if (resData.isNewRewardClaimed || !resData.alreadyClaimed) {
          setJustClaimed(true);
          setProduct((prev) => (prev ? { ...prev, IsAlreadyRewarded: true } : prev));
          startClaimAnimation();
        } else {
          setJustClaimed(false);
          setClaimAnimStage("idle");
        }
      } else {
        setMobileError(resData.error || "Failed to link mobile number. Please try again.");
      }
    } catch (err) {
      console.error("Error claiming royalty points:", err);
      setMobileError(err?.message || "Network error. Please try again.");
    } finally {
      setMobileLoading(false);
    }
  };

  const openLoyaltyModal = (isClaimClick = false) => {
    setShowLoyaltyModal(true);
    setMobileError("");
    const clean = (savedMobile || mobileNumber || "").replace(/\D/g, "");

    if (clean.length === 10) {
      if (isClaimClick && !isProductRewardClaimed) {
        // User clicked CLAIM REWARD with linked mobile: automatically claim!
        claimPointsForMobile(clean);
      } else {
        fetchLoyaltyHistory(clean);
        if (isClaimClick && !isProductRewardClaimed) {
          setJustClaimed(true);
          startClaimAnimation();
        } else {
          setJustClaimed(false);
          setClaimAnimStage("idle");
        }
      }
    } else {
      setJustClaimed(false);
      setClaimAnimStage("idle");
    }
  };

  useEffect(() => {
    try {
      const { deviceId } = getDeviceInfo();
      const cached = localStorage.getItem(`user_mobile_${deviceId}`);
      if (cached) {
        setMobileNumber(cached);
        setSavedMobile(cached);
        setMobileSubmitted(true);
        fetchLoyaltyHistory(cached);
      }
    } catch (err) {
      // ignore
    }
  }, []);

  const fetchDisplayConfig = async (companyId, companyGrpId) => {
    if (!companyId || !companyGrpId) return;
    try {
      const res = await fetch(
        `${appConfig.apiBaseUrl}/tagros/display-config?companyid=${companyId}&companygrpid=${companyGrpId}`
      );
      const result = await res.json();
      if (result.success && result.data) {
        setDisplayConfig(result.data);
      }
    } catch (err) {
      console.error("Error fetching display config:", err);
    }
  };

  const toggleSection = async (sectionName, isVisible) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      return {
        ...current,
        [sectionName]: {
          ...(current[sectionName] || { fields: {} }),
          visible: isVisible,
        },
      };
    });

    try {
      if (!product?.CompanyID || !product?.CompanyGrpID) return;
      await fetch(`${appConfig.apiBaseUrl}/tagros/save-display-config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyid: product.CompanyID,
          companygrpid: product.CompanyGrpID,
          sectionname: sectionName,
          isvisible: isVisible,
        }),
      });
    } catch (err) {
      console.error("Error saving section config:", err);
    }
  };

  const toggleField = async (sectionName, fieldName, isVisible) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      const sec = current[sectionName] || { visible: true, fields: {} };
      return {
        ...current,
        [sectionName]: {
          ...sec,
          fields: {
            ...(sec.fields || {}),
            [fieldName]: isVisible,
          },
        },
      };
    });

    try {
      if (!product?.CompanyID || !product?.CompanyGrpID) return;
      await fetch(`${appConfig.apiBaseUrl}/tagros/save-display-config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyid: product.CompanyID,
          companygrpid: product.CompanyGrpID,
          sectionname: sectionName,
          fieldname: fieldName,
          isvisible: isVisible,
        }),
      });
    } catch (err) {
      console.error("Error saving field config:", err);
    }
  };

  const result = removeProtocol(fullUrl);

  console.log(result);
  // Output:
  // 192.168.1.13:3000/VPPpP5PF5U51B2ZyXzlI

  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!sku) {
        setError("No code or SKU provided.");
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      setProduct(null);
      setDecodedRsn(null);
      setEncodedRsn(null);
      setEncodedSku(null);
      setSignature(null);

      const rawValue = String(sku).trim();
      const tokenCandidateValue = rawValue;
      const tokenInfo = await decodeTagrosToken(tokenCandidateValue || rawValue, appConfig.signatureSecret);
      const decodedValue = tokenInfo.decodedRsn;
      const encodedSkuValue = tokenCandidateValue || tokenInfo.encodedRsn || rawValue;

      setDecodedRsn(decodedValue);
      setEncodedRsn(tokenInfo.encodedRsn);
      setTokenCandidate(tokenCandidateValue);
      setEncodedSku(encodedSkuValue);
      setSignature(tokenInfo.signature);

      try {
        console.log("Tagros tokenInfo", {
          rawValue,
          scanned: rawValue,
          tokenCandidate: fullUrl,
          decoded: decodedValue,
          encodedRsn: tokenInfo.encodedRsn,
          encodedSku: encodedSkuValue,
          signature: tokenInfo.signature,
        });

        const response = await fetch(
          `${appConfig.baseUrl}/tagros/scan`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              scanned: rawValue,
              decoded: decodedValue,
              tokenCandidate: fullUrl,
              encodedRsn: tokenInfo.encodedRsn,
              signature: tokenInfo.signature,
            }),
          }
        );

        const result = await response.json();
        setScanStatus(result.status);

        if (!response.ok || !result.success) {
          const serverError = result?.error || "Product not found";
          setError(serverError);
          return;
        }
        console.log("Product fetch result:", result);

        if (result?.data) {
          setProduct(result.data);

          fetchFeedbackList();
          if (result.data.CompanyID) {
            fetchDisplayConfig(result.data.CompanyID, result.data.CompanyGrpID || 1);
          }
          fetchPlantLocation(result.data.BatchID || 0);


        } else {
          setError("No product data found for this code.");
        }

        if (!tokenInfo.decodedRsn && result?.request?.decodedRsn) {
          setDecodedRsn(result.request.decodedRsn);
        }
        if (!tokenInfo.encodedRsn && result?.request?.encodedRsn) {
          setEncodedRsn(result.request.encodedRsn);
        }
        if (!encodedSkuValue && result?.request?.encodedSku) {
          setEncodedSku(result.request.encodedSku);
        }
        await getAndSaveUserLocation(result.data, result.status);
      } catch (err) {
        console.error("Error fetching product:", err);
        setError("Unable to fetch product details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [sku]);
  const fetchFeedbackList = async () => {
    try {

      const res = await fetch(
        `${appConfig.apiBaseUrl}/tagros/feedbackList`
      );

      const result = await res.json();

      if (result.success) {
        setFeedbackList(result.data);
      }

    } catch (err) {
      console.log(err);
    }
  };

  const fetchPlantLocation = async (batchId) => {
    try {
      const response = await fetch(
        `${appConfig.apiBaseUrl}/tagros/plant-location/${batchId}`
      );

      const result = await response.json();

      if (result.success) {
        setPlantLocation(result.data);
      }
    } catch (err) {
      console.error("Error fetching plant location:", err);
    }
  };



  const saveLocationToServer = async (productData, status, lat, lon, area, city, state, fullAddress) => {
    try {
      const { deviceId, isUnique } = getDeviceInfo();
      const saveRes = await fetch(`${appConfig.apiBaseUrl}/tagros/saveUserLocation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserID: null,
          RSNID: productData?.RSNID || null,
          BatchID: productData?.BatchID || null,
          ProductID: productData?.productId || null,
          Status: status?.id ?? null,
          Latitude: lat,
          Longitude: lon,
          Area: area,
          City: city,
          State: state,
          FullAddress: fullAddress,
          DeviceID: deviceId,
          IsUnique: isUnique,
          CompanyID: productData?.CompanyID || null,
          RoyaltyPoints: productData?.EarnedPoints || 0,
          MobileNumber: savedMobile || mobileNumber || null,
        }),
      });

      if (!saveRes.ok) {
        throw new Error("Failed to save location to server");
      }

      const resData = await saveRes.json();
      if (resData.insertedId) {
        setLastLocationId(resData.insertedId);
      }

      setGpsStatus(lat && lon ? "Location saved successfully" : "Scan logged successfully");
    } catch (error) {
      console.error("Location save error:", error);
      setGpsStatus("Failed to save location");
    }
  };

  const handleClaimRoyaltyPoints = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setMobileError("");

    const clean = String(mobileNumber).replace(/\D/g, "");
    if (clean.length < 10) {
      setMobileError("Please enter a valid 10-digit mobile number.");
      return;
    }
    await claimPointsForMobile(clean);
  };

  const getAndSaveUserLocation = async (productData, status) => {
    if (!window.isSecureContext) {
      setGpsStatus("Location requires HTTPS or localhost");
      setMessage((currentMessage) =>
        currentMessage || "Location access works only on HTTPS or localhost."
      );
      await saveLocationToServer(productData, status, 0.0, 0.0, "Unknown", "Unknown", "Unknown", "Not Secure Context (Requires HTTPS/localhost)");
      return;
    }

    if (!navigator.geolocation) {
      setGpsStatus("Geolocation not supported");
      setMessage((currentMessage) =>
        currentMessage || "Geolocation is not supported in this browser."
      );
      await saveLocationToServer(productData, status, 0.0, 0.0, "Unknown", "Unknown", "Unknown", "Geolocation Not Supported");
      return;
    }

    setGpsStatus("Fetching your location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          setGpsStatus("Resolving address...");
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`,
            { headers: { Accept: "application/json" } }
          );
          const data = await res.json();

          const area =
            data.address?.neighbourhood ||
            data.address?.suburb ||
            data.address?.village ||
            data.address?.town ||
            "Unknown";
          const city =
            data.address?.city ||
            data.address?.district ||
            data.address?.state_district ||
            data.address?.town ||
            "Unknown";
          const state = data.address?.state || "Unknown";
          const fullAddress = data.display_name || `${area}, ${city}, ${state}`;

          await saveLocationToServer(productData, status, lat, lon, area, city, state, fullAddress);
        } catch (error) {
          console.error("Location save error:", error);
          setGpsStatus("Failed to save location");
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          await saveLocationToServer(productData, status, lat, lon, "Unknown", "Unknown", "Unknown", "OSM Reverse Geocoding Failed");
        }
      },
      async (error) => {
        let nextMessage = "Location access denied";

        if (error.code === 1) nextMessage = "Permission denied";
        if (error.code === 2) nextMessage = "Location unavailable";
        if (error.code === 3) nextMessage = "Timeout";

        setGpsStatus(nextMessage);
        setMessage((currentMessage) => currentMessage || `Location error: ${nextMessage}.`);
        await saveLocationToServer(productData, status, 0.0, 0.0, "Unknown", "Unknown", "Unknown", `GPS Error: ${nextMessage}`);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
    );
  };


  if (loading) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-gray-100">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-[#295a80]" />
        <p className="mt-5 text-gray-600">Loading product details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="flex items-center justify-center border-b-2 border-gray-200 bg-white p-3 md:p-4 shadow-sm">
          <img
            src={logo}
            alt="Company Logo"
            className="h-8 sm:h-10 md:h-12 lg:h-14 w-auto object-contain"
            style={{ maxWidth: "220px" }}
          />
        </div>

        <div className="flex flex-col items-center justify-center py-12">
          <div className="max-w-lg rounded-lg bg-white p-8 text-center shadow-md">
            <p className="mt-4 text-gray-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!product) {
    return null;
  }

  const getStatusStyle = () => {
    switch (Number(scanStatus?.id)) {
      case 1:
        return {
          bg: "bg-green-50",
          border: "border-green-500",
          text: "text-green-700",
          icon: <AiFillProduct />,
        };

      case 2:
        return {
          bg: "bg-yellow-50",
          border: "border-yellow-500",
          text: "text-yellow-700",
          icon: <TiWarning />,
        };

      case 3:
        return {
          bg: "bg-red-50",
          border: "border-red-500",
          text: "text-red-700",
          icon: <HiDuplicate />,
        };

      default:
        return null;
    }
  };

  const statusStyle = getStatusStyle();

  const sendFeedback = async () => {

    if (!selectedFeedback) {
      alert("Please select feedback.");
      return;
    }

    try {

      setSendingFeedback(true);

      const res = await fetch(
        `${appConfig.apiBaseUrl}/tagros/saveFeedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            DeviceID: getDeviceInfo().deviceId,
            FeedbackID: selectedFeedback,
            FeedbackText: feedbackText,
            RSNID: product.RSNID
          })
        }
      );

      const result = await res.json();

      if (result.success) {
        localStorage.setItem(
          `feedback_${product.RSNID}`,
          JSON.stringify({
            submitted: true,
            feedbackId: selectedFeedback,
            feedbackText: feedbackText
          })
        );
        setFeedbackStatus("submitted");
        setFeedbackSubmitted(true);
      } else {
        alert(result.error);
      }

    } catch (err) {

      console.log(err);
      alert("Unable to submit feedback.");

    } finally {
      setSendingFeedback(false);
    }

  };
  const getFeedbackIcon = (enumvalue) => {
    switch (Number(enumvalue)) {
      case 1:
        return <FaThumbsUp className="text-3xl text-green-600" />;

      case 2:
        return <BsBoxSeamFill className="text-3xl text-orange-500" />;

      case 3:
        return <FcDeleteDatabase className="text-3xl" />;

      case 4:
        return <MdReportProblem className="text-3xl text-purple-600" />;

      default:
        return null;
    }
  };
  const getSecConfig = (sectionName) => {
    if (!displayConfig) return null;
    const secKey = Object.keys(displayConfig).find(
      (k) => k.trim().toLowerCase() === String(sectionName).trim().toLowerCase()
    );
    return secKey ? displayConfig[secKey] : null;
  };

  const getFldConfig = (sectionName, fieldName) => {
    const sec = getSecConfig(sectionName);
    if (!sec || !sec.fields) return null;
    const fKey = Object.keys(sec.fields).find(
      (fk) => fk.trim().toLowerCase() === String(fieldName).trim().toLowerCase()
    );
    return fKey ? sec.fields[fKey] : null;
  };

  const isSecVisible = (sectionName) => {
    const sec = getSecConfig(sectionName);
    return sec ? sec.visible !== false : true;
  };

  const getSecTitle = (sectionName, defaultTitle) => {
    const sec = getSecConfig(sectionName);
    return sec?.title || defaultTitle || sectionName;
  };

  const isFldVisible = (sectionName, fieldName) => {
    const f = getFldConfig(sectionName, fieldName);
    if (typeof f === 'object' && f !== null) return f.visible !== false;
    return f !== false;
  };

  const getFldTitle = (sectionName, fieldName, defaultLabel) => {
    const f = getFldConfig(sectionName, fieldName);
    if (typeof f === 'object' && f !== null) return f.title || defaultLabel;
    return defaultLabel;
  };

  const feedbackOptions = feedbackList
    .filter((item) => isFldVisible("Send Feedback", item.description))
    .map((item) => ({
      value: String(item.enumvalue),
      label: getFldTitle("Send Feedback", item.description, item.description),
      icon: getFeedbackIcon(item.enumvalue),
    }));

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      {isSecVisible("Company Logo") && (
        <div className="flex items-center justify-center border-b-2 border-gray-200 bg-white p-3 md:p-4 shadow-sm">
          <img
            src={getSecConfig("Company Logo")?.companylogo ? `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/public/companylogos/${getSecConfig("Company Logo").companylogo}` : logo}
            alt="Company Logo"
            className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto object-contain"
            style={{ maxWidth: "220px" }}
          />
        </div>
      )}

      <div className="mx-auto max-w-lg md:max-w-2xl lg:max-w-3xl px-3 md:px-5 py-3">

        {isSecVisible("Status Banner") &&
          statusStyle &&
          !showFeedbackForm &&
          !feedbackSubmitted && (
            <div
              className={`mb-5 rounded-lg border px-4 py-3 ${statusStyle.bg} ${statusStyle.border}`}
            >
              <div
                className={`flex items-center justify-center gap-2 font-semibold ${statusStyle.text}`}
              >
                <span>{statusStyle.icon}</span>
                <span>{scanStatus.name}</span>
              </div>

              {Number(scanStatus.id) === 3 && (
                <p className="mt-3 text-center text-sm text-red-600">
                  This product has been scanned multiple times and may be a duplicate.
                </p>
              )}
            </div>
          )}

        {/* Section 1: Product Image */}
        {Number(scanStatus?.id) !== 3 &&
          !showFeedbackForm &&
          !feedbackSubmitted &&
          isSecVisible("Product Image") &&
          product.ProductImage && (
            <div className="mb-5 flex justify-center">
              <img
                src={
                  String(product.ProductImage).includes("/")
                    ? `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/uploads/${product.ProductImage}`
                    : product.productId
                      ? `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/uploads/${product.productId}/${product.ProductImage}`
                      : `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/uploads/productimages/${product.ProductImage}`
                }
                alt={product.ProductName}
                className="h-64 w-64 rounded-lg border object-contain shadow"
                onError={(e) => {
                  if (product.ProductImage && !e.target.dataset.triedFallback) {
                    e.target.dataset.triedFallback = "true";
                    e.target.src = `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/uploads/productimages/${product.ProductImage}`;
                  } else {
                    e.target.style.display = "none";
                  }
                }}
              />
            </div>
          )}

        {/* Section 2: Product Details */}
        {Number(scanStatus?.id) !== 3 &&
          !showFeedbackForm &&
          !feedbackSubmitted &&
          isSecVisible("Product Details") && (() => {
            const sectionTitle = getSecTitle("Product Details", "Product Details");
            const rows = [
              isFldVisible("Product Details", "Product Name") && [getFldTitle("Product Details", "Product Name", "Product Name"), product.ProductName],
              isFldVisible("Product Details", "Product Code") && product.ProductCode && [getFldTitle("Product Details", "Product Code", "Product Code"), product.ProductCode],
              isFldVisible("Product Details", "Batch Name") && [getFldTitle("Product Details", "Batch Name", "Batch Name"), product.BatchName],
              isFldVisible("Product Details", "Mfg Date") && [getFldTitle("Product Details", "Mfg Date", "Mfg.Date"), formatDate(product.MfgDate)],
              isFldVisible("Product Details", "Exp Date") && [getFldTitle("Product Details", "Exp Date", "Exp.Date"), formatDate(product.ExpDate)],
            ].filter(Boolean);

            if (rows.length === 0) return null;

            return (
              <div className="overflow-hidden border-2 border-gray-400 bg-white shadow-md">
                <div className="border-b-2 border-gray-400 bg-[#295a80] px-4 py-3">
                  <h2 className="text-center text-lg font-semibold text-white md:text-xl">
                    {sectionTitle}
                  </h2>
                </div>

                <div className="flex flex-col">
                  {rows.map(([label, value], index) => (
                    <div
                      key={label}
                      className={`flex border-b border-gray-400 last:border-b-0 ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                        }`}
                    >
                      <div className="flex w-[45%] items-center border-r border-gray-400 px-3 py-3 text-sm font-bold text-[#295a80] sm:px-5 sm:text-[14px] lg:px-6 lg:text-[15px]">
                        {label}
                      </div>
                      <div className="flex w-[55%] items-center break-words px-4 py-3 text-sm font-medium text-gray-800 sm:px-5 sm:text-[15px] lg:px-6 lg:text-[16px]">
                        {value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

        {/* Section 3: Manufacturing Details */}
        {Number(scanStatus?.id) !== 3 &&
          !showFeedbackForm &&
          !feedbackSubmitted &&
          plantLocation &&
          isSecVisible("Manufacturing Details") && (() => {
            const sectionTitle = getSecTitle("Manufacturing Details", "Manufacturing Details");
            const mfgRows = [
              isFldVisible("Manufacturing Details", "Branch Name") && plantLocation.lcm_locationname && [getFldTitle("Manufacturing Details", "Branch Name", "Branch Name"), plantLocation.lcm_locationname],
              isFldVisible("Manufacturing Details", "Machine Name") && plantLocation.mm_machinename && [getFldTitle("Manufacturing Details", "Machine Name", "Machine Name"), plantLocation.mm_machinename],
              isFldVisible("Manufacturing Details", "Address") && [
                plantLocation.lcm_locationstreet1,
                plantLocation.lcm_city,
                plantLocation.lcm_state ? `${plantLocation.lcm_state}${plantLocation.lcm_postalcode ? ` - ${plantLocation.lcm_postalcode}` : ''}` : null,
              ].filter(Boolean).join(", ") && [
                getFldTitle("Manufacturing Details", "Address", "Address"),
                [
                  plantLocation.lcm_locationstreet1,
                  plantLocation.lcm_city,
                  plantLocation.lcm_state ? `${plantLocation.lcm_state}${plantLocation.lcm_postalcode ? ` - ${plantLocation.lcm_postalcode}` : ''}` : null,
                ].filter(Boolean).join(", "),
              ],
              isFldVisible("Manufacturing Details", "Contact Number") && plantLocation.lcm_contactnumber && [getFldTitle("Manufacturing Details", "Contact Number", "Contact Number"), plantLocation.lcm_contactnumber],
              isFldVisible("Manufacturing Details", "Email") && plantLocation.lcm_emailid && [getFldTitle("Manufacturing Details", "Email", "Email"), plantLocation.lcm_emailid],
            ].filter(Boolean);

            if (mfgRows.length === 0) return null;

            return (
              <div className="mt-5 overflow-hidden border-2 border-gray-400 bg-white shadow-md">
                {/* Header */}
                <div className="border-b-2 border-gray-400 bg-[#295a80] px-4 py-3">
                  <h2 className="text-center text-lg font-semibold text-white md:text-xl">
                    {sectionTitle}
                  </h2>
                </div>

                {/* Table */}
                <div className="flex flex-col">
                  {mfgRows.map(([label, value], index) => (
                    <div
                      key={label}
                      className={`flex border-b border-gray-400 last:border-b-0 ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                        }`}
                    >
                      {/* Left Column */}
                      <div className="w-[45%] border-r border-gray-400 px-4 py-3 text-sm font-bold text-[#295a80] sm:px-5 sm:text-[14px] lg:px-6 lg:text-[15px] flex items-center">
                        {label}
                      </div>

                      {/* Right Column */}
                      <div className="w-[55%] px-4 py-3 text-sm font-medium text-gray-800 sm:px-5 sm:text-[15px] lg:px-6 lg:text-[16px] flex items-center justify-start text-left">
                        {value || "-"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

        {Number(scanStatus?.id) !== 3 && (isSecVisible("Send Feedback") || isSecVisible("Royalty Rewards")) && (
          <div className="mt-3 rounded-xl border bg-white p-4 shadow">
            {!showFeedbackForm && !feedbackSubmitted && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {isSecVisible("Send Feedback") && (
                  <button
                    onClick={() => {
                      const feedbackKey = `feedback_${product.RSNID}`;

                      const savedFeedback = localStorage.getItem(feedbackKey);

                      if (savedFeedback) {
                        const feedback = JSON.parse(savedFeedback);

                        if (feedback.submitted) {
                          setFeedbackSubmitted(true);
                          setShowFeedbackForm(false);
                          return;
                        }
                      }

                      setShowFeedbackForm(true);
                    }}
                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#295a80] py-3 font-semibold text-white transition hover:bg-[#214c6d] shadow-sm"
                  >
                    <IoIosSend className="text-xl" />
                    <span>{getSecTitle("Send Feedback", "SEND FEEDBACK").toUpperCase()}</span>
                  </button>
                )}

                {isSecVisible("Royalty Rewards") && isOriginalProduct && (
                  <div className="flex flex-col">
                    <button
                      onClick={() => openLoyaltyModal(true)}
                      className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#295a80] hover:bg-[#214c6d] py-3 font-semibold text-white shadow-sm transition duration-200 cursor-pointer"
                    >
                      <span>{isProductRewardClaimed ? "VIEW REWARD" : "CLAIM REWARD"}</span>
                    </button>
                    {savedMobile && (
                      <div className="flex items-center justify-center gap-1.5 text-[11px] text-gray-500 mt-2">
                        <span>Linked Mobile: <strong className="text-gray-700 font-semibold">+91 {savedMobile}</strong></span>
                        <button
                          type="button"
                          onClick={() => {
                            setMobileNumber(savedMobile);
                            setIsEditingMobile(true);
                            setShowLoyaltyModal(true);
                          }}
                          className="text-[#295a80] hover:underline font-bold cursor-pointer ml-1"
                        >
                          Change
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {showFeedbackForm && !feedbackSubmitted && (
              <>
                <h3 className="mb-4 text-lg font-semibold text-[#295a80]">
                  {displayConfig?.["Send Feedback"]?.title || "Feedback"}
                </h3>

                <div className="grid grid-cols-2 gap-4">

                  {feedbackOptions.map((item) => (
                    <div
                      key={item.value}
                      onClick={() => setSelectedFeedback(item.value)}
                      className={`relative cursor-pointer rounded-xl border p-2 text-center transition-all duration-300
                ${selectedFeedback === item.value
                          ? "border-green-500 bg-green-50 shadow"
                          : "border-gray-200 hover:border-green-300"
                        }`}
                    >
                      <div
                        className={`absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full border-2
                  ${selectedFeedback === item.value
                            ? "border-green-600"
                            : "border-gray-400"
                          }`}
                      >
                        {selectedFeedback === item.value && (
                          <div className="h-1.5 w-1.5 rounded-full bg-green-600"></div>
                        )}
                      </div>
                      <div
                        className={`mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full
                  ${selectedFeedback === item.value
                            ? "bg-green-100"
                            : "bg-gray-100"
                          }`}
                      >
                        {item.icon}
                      </div>

                      <p className="text-sm font-semibold text-[#295a80]">
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="mt-5">
                  <label className="mb-2 block text-sm font-semibold text-[#295a80]">
                    Additional Feedback
                  </label>

                  <textarea
                    rows={5}
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e.target.value)}
                    placeholder="Write your feedback here..."
                    className="w-full rounded-lg border border-gray-300 p-3 outline-none focus:border-[#295a80]"
                  />
                </div>
                <button
                  onClick={sendFeedback}
                  disabled={!selectedFeedback || sendingFeedback}
                  className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-[#295a80] py-3 font-semibold text-white transition hover:bg-[#214c6d] disabled:bg-gray-400"
                >
                  <IoIosSend className="text-xl" />SUBMIT FEEDBACK
                </button>
              </>
            )}
            {feedbackSubmitted && (
              <div className="rounded-xl border border-green-100 bg-green-50 p-2">
                <div className="flex items-center gap-2">
                  <div className="flex h-15 w-15 items-center justify-center rounded-full bg-green-500">
                    <FaCheckCircle className="text-5xl text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-md font-bold text-green-700">
                      {feedbackStatus === "submitted"
                        ? "Feedback Submitted Successfully!"
                        : "Feedback Already Submitted!"}
                    </h3>
                    <p className="mt-2 text-gray-600">
                      Thank you for your valuable feedback.
                    </p>
                  </div>
                </div>
              </div>
            )}

          </div>
        )}

        {/* Loyalty Points & History Modal */}
        {/* Claim Reward / Loyalty Modal */}
        {showLoyaltyModal && (() => {
          const isMobileRegistered = Boolean(savedMobile) && !isEditingMobile;

          if (!isMobileRegistered) {
            return (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-xs p-4 animate-in fade-in duration-150">
                <div className="relative w-full max-w-xs sm:max-w-sm bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 sm:p-6 text-center animate-in zoom-in-95 duration-150">
                  {/* Close button */}
                  <button
                    type="button"
                    onClick={() => {
                      setShowLoyaltyModal(false);
                      setIsEditingMobile(false);
                      setMobileError("");
                    }}
                    className="absolute top-3.5 right-3.5 p-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition cursor-pointer"
                    aria-label="Close"
                  >
                    <IoIosClose className="text-2xl" />
                  </button>

                  {/* Icon & Title */}
                  <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-blue-50 text-[#295a80]">
                    <FaGift className="text-lg" />
                  </div>
                  <h3 className="text-base font-bold text-gray-900 leading-tight">
                    {isEditingMobile ? "Update Mobile Number" : "Enter Mobile Number"}
                  </h3>
                  <p className="text-xs text-gray-500 mt-1 mb-4 leading-normal">
                    {isEditingMobile
                      ? "Enter your new number to update your rewards account"
                      : Number(product?.EarnedPoints || 0) > 0
                        ? `Enter 10-digit number to claim +${product.EarnedPoints} points`
                        : "Enter your 10-digit number to access reward points"}
                  </p>

                  {/* Minimal Input Form */}
                  <form onSubmit={handleClaimRoyaltyPoints} className="space-y-3">
                    <div className="flex rounded-xl border border-gray-300 focus-within:border-[#295a80] focus-within:ring-2 focus-within:ring-[#295a80]/20 bg-gray-50/50 transition overflow-hidden">
                      <div className="flex items-center justify-center bg-gray-100 px-3 text-xs font-semibold text-gray-700 border-r border-gray-200 select-none">
                        +91
                      </div>
                      <input
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={10}
                        placeholder="10-digit mobile number"
                        value={mobileNumber}
                        onChange={(e) => {
                          setMobileNumber(e.target.value.replace(/\D/g, ""));
                          setMobileError("");
                        }}
                        className="w-full py-2.5 px-3 text-sm font-semibold text-gray-900 placeholder:text-gray-400 placeholder:font-normal focus:outline-none tracking-wider bg-transparent"
                        autoFocus
                      />
                    </div>

                    {mobileError && (
                      <p className="text-[11px] text-red-600 font-medium text-left">{mobileError}</p>
                    )}

                    <button
                      type="submit"
                      disabled={mobileLoading}
                      className="w-full flex items-center justify-center gap-2 rounded-xl bg-[#295a80] hover:bg-[#214c6d] active:scale-[0.98] py-2.5 text-sm font-bold text-white shadow-xs transition duration-200 disabled:opacity-50 cursor-pointer"
                    >
                      {mobileLoading ? (
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                          <span>{isEditingMobile ? "Updating..." : "Verifying..."}</span>
                        </div>
                      ) : (
                        <span>{isEditingMobile ? "Update Number" : "Continue"}</span>
                      )}
                    </button>

                    {savedMobile && isEditingMobile && (
                      <button
                        type="button"
                        onClick={() => {
                          setIsEditingMobile(false);
                          setMobileNumber(savedMobile);
                          setMobileError("");
                        }}
                        className="text-xs font-semibold text-gray-400 hover:text-gray-600 cursor-pointer transition pt-1 block mx-auto"
                      >
                        Cancel
                      </button>
                    )}
                  </form>
                </div>
              </div>
            );
          }

          // When Mobile is Registered: Full-screen UPI App Style (Matching the reference screenshot)
          return (
            <div className="fixed inset-0 z-50 bg-white flex flex-col justify-between items-center px-6 py-8 sm:py-10 select-none overflow-y-auto animate-in fade-in duration-300">
              {/* Top Header / Close & Change Number */}
              <div className="w-full max-w-sm flex items-center justify-between gap-2">
                <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600 font-medium bg-gray-50 border border-gray-200 px-2.5 py-1 rounded-full shadow-2xs">
                  <span>Linked: <strong className="text-gray-800 font-bold">+91 {savedMobile}</strong></span>
                  <button
                    type="button"
                    onClick={() => {
                      setMobileNumber(savedMobile);
                      setIsEditingMobile(true);
                      setClaimAnimStage("idle");
                      setJustClaimed(false);
                    }}
                    className="ml-1 text-[#295a80] hover:text-[#214c6d] font-bold underline cursor-pointer"
                  >
                    Change
                  </button>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setShowLoyaltyModal(false);
                    setJustClaimed(false);
                    setClaimAnimStage("idle");
                  }}
                  className="p-1.5 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-700 transition cursor-pointer shrink-0"
                  aria-label="Close"
                >
                  <IoIosClose className="text-3xl" />
                </button>
              </div>

              {/* Center Hero (Google Pay / UPI App Style) */}
              <div
                key={animKey}
                className="flex flex-col items-center justify-center text-center my-auto py-6 max-w-sm w-full"
              >
                {/* Animated Blue Checkmark Circle (Matching Reference Image) */}
                <div
                  className={`mb-6 flex h-24 w-24 sm:h-28 sm:w-28 items-center justify-center rounded-full bg-[#1a73e8] shadow-xl shadow-blue-500/25 ${claimAnimStage === "reward" ? "animate-phonepe-pop" : ""
                    }`}
                >
                  <svg
                    className="w-12 h-12 sm:w-14 sm:h-14 text-white"
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 27l8 8 16-16"
                      stroke="currentColor"
                      strokeWidth="5.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={claimAnimStage === "reward" ? "phonepe-tick-path" : ""}
                    />
                  </svg>
                </div>

                {/* Title */}
                <h2
                  className={`text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight leading-snug ${claimAnimStage === "reward" ? "animate-slide-up" : ""
                    }`}
                >
                  {justClaimed || claimAnimStage === "reward" || !isProductRewardClaimed
                    ? "Reward Credited!"
                    : "Reward Already Claimed"}
                </h2>

                {/* Subtitle - Cool and Professional Scheme Message (No Product Name Mentioned) */}
                <p
                  className={`text-sm sm:text-base font-medium text-gray-600 mt-2.5 max-w-xs sm:max-w-sm mx-auto leading-relaxed ${claimAnimStage === "reward" ? "animate-slide-up" : ""
                    }`}
                >
                  {justClaimed || claimAnimStage === "reward" || !isProductRewardClaimed
                    ? `Congratulations! You have availed ${product?.EarnedPoints || 0} points successfully under ${product?.SchemeName ? `the ${product.SchemeName} scheme` : "the Loyalty Rewards Program"
                    }.`
                    : `You have already availed ${product?.EarnedPoints || 0} points successfully under ${product?.SchemeName ? `the ${product.SchemeName} scheme` : "the Loyalty Rewards Program"
                    }.`}
                </p>

                {/* Timestamp */}
                <p className="text-xs sm:text-sm text-gray-400 font-medium mt-6">
                  {new Date().toLocaleString("en-IN", {
                    day: "numeric",
                    month: "short",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </p>
              </div>

              {/* Bottom Action Area: My Points, History & Got it Button */}
              <div className="w-full max-w-sm flex flex-col items-center gap-4 pt-4 pb-2">
                {/* My Points & History Bar */}
                <div className="w-full flex items-center justify-between rounded-2xl bg-gray-50/90 border border-gray-200/80 px-4 py-3 shadow-xs">
                  {/* My Points - Total points of that user */}
                  <div className="flex items-center gap-2.5">
                    <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-[#1a73e8]">
                      <FaAward className="text-lg" />
                    </div>
                    <div className="text-left">
                      <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">
                        My Points
                      </span>
                      <span className="text-sm sm:text-base font-extrabold text-gray-900 leading-tight">
                        {totalLoyaltyPoints > 0 ? totalLoyaltyPoints : (product?.EarnedPoints || 0)} pts
                      </span>
                    </div>
                  </div>

                  {/* Option / Icon of History */}
                  <button
                    type="button"
                    onClick={() => {
                      setShowHistorySheet(true);
                      const clean = (savedMobile || mobileNumber || "").replace(/\D/g, "");
                      if (clean.length === 10) {
                        fetchLoyaltyHistory(clean);
                      }
                    }}
                    className="flex items-center gap-1.5 rounded-full border border-gray-200 bg-white hover:bg-gray-100 active:scale-95 px-3.5 py-1.5 text-xs font-bold text-gray-700 transition shadow-2xs cursor-pointer"
                  >
                    <FaHistory className="text-[11px] text-[#1a73e8]" />
                    <span>History</span>
                  </button>
                </div>

                {/* Got it Button (Matching Reference Image) */}
                <button
                  type="button"
                  onClick={() => {
                    setShowLoyaltyModal(false);
                    setJustClaimed(false);
                    setClaimAnimStage("idle");
                  }}
                  className="rounded-full border border-gray-300 hover:border-gray-400 active:scale-95 bg-white hover:bg-gray-50 px-10 py-2 text-sm font-semibold text-[#1a73e8] shadow-xs transition cursor-pointer"
                >
                  Got it
                </button>
              </div>

              {/* History Slide-up Sheet / Modal */}
              {showHistorySheet && (
                <div className="fixed inset-0 z-60 flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-xs p-0 sm:p-4 animate-in fade-in duration-200">
                  <div className="w-full max-w-md bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl p-5 border border-gray-100 max-h-[82vh] flex flex-col">
                    <div className="flex items-center justify-between pb-3 border-b border-gray-100">
                      <div className="flex items-center gap-2">
                        <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-blue-50 text-[#1a73e8]">
                          <FaHistory className="text-xs" />
                        </div>
                        <div>
                          <h3 className="text-xs font-bold uppercase tracking-wider text-gray-800">
                            Reward History
                          </h3>
                          <p className="text-[10px] text-gray-500">
                            Total: {totalLoyaltyPoints > 0 ? totalLoyaltyPoints : (product?.EarnedPoints || 0)} pts
                          </p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => setShowHistorySheet(false)}
                        className="p-1 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-700 cursor-pointer"
                      >
                        <IoIosClose className="text-2xl" />
                      </button>
                    </div>

                    <div className="py-3 overflow-y-auto space-y-2 flex-1 pr-1">
                      {fetchingHistory ? (
                        <div className="py-8 text-center text-xs text-gray-400">Loading history...</div>
                      ) : loyaltyHistory.length === 0 ? (
                        <div className="py-8 text-center text-xs text-gray-400">No previous rewards found.</div>
                      ) : (
                        loyaltyHistory.map((item, idx) => {
                          const pts = Number(item.RoyaltyPoints || item.points || item.Points || 0);
                          const scanTime = item.scantime || item.ScanTime || item.CreatedAt;
                          const dateStr =
                            item.FormattedScanTime ||
                            (scanTime
                              ? new Date(scanTime).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                              : "-");
                          return (
                            <div
                              key={item.RewardHistoryID || item.id || idx}
                              className="flex items-center justify-between p-2.5 rounded-xl border border-gray-100 bg-gray-50/70"
                            >
                              <div className="flex-1 pr-2 truncate">
                                <p className="font-bold text-xs text-gray-900 truncate">
                                  {item.RSNID ? `Reward Points` : "Loyalty Reward Points"}
                                </p>
                                <p className="text-[10px] text-gray-500">{dateStr}</p>
                              </div>
                              <span className="px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-emerald-100 text-emerald-700 shrink-0">
                                +{pts} pts
                              </span>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })()}

      </div>
    </div>
  );
};

export default TagrosProductDetailsPage;

